import { css } from 'lit';
export const accordionStyles = css `
    :host {
        display: block;
    }
    .hlx-accordion-top-line {
        border-top: 1px solid lightgray;
    }
    .hlx-accordion {
        position: relative;
    }
    .hlx-accordion-inverted {
        background-color: var(--hlx-background-color-inverted);
    }
`;
//# sourceMappingURL=accordion.styles.js.map